module.exports = __webpack_public_path__ + "img/recipemenu.14251808.svg";